import _isNil from 'lodash/isNil';
import React from 'react';
import { IProject } from '@Data/projects/Interfaces';
import Roles from '../../HomeViewRoles';
import { ManageProjectType } from '../ManageProject/ManageProjectDialog';
import CreateProjectCard from './CreateProjectCard';
import ProjectCard from './ProjectCard';
import Styles from './ProjectCard.scss';
import ProjectCardSkeleton from './ProjectCardSkeleton';

interface IProjectCardListProps {
    isLoading: boolean;
    onClick: (project: IProject) => void;
    onEdit: (project: IProject, manageProjectType: ManageProjectType) => void;
    onDelete: (project: IProject) => void;
    projects: Array<IProject>;
    onCreateProject: () => void;
}

const ProjectCardList = (props: IProjectCardListProps) => {
    const { isLoading, onClick, onEdit, onDelete, projects, onCreateProject } =
        props;

    const panels: Array<any> = [];
    let divRole: string;
    if (isLoading) {
        panels.push(
            <ProjectCardSkeleton key={'pcs1'} />,
            <ProjectCardSkeleton key={'pcs2'} />,
            <ProjectCardSkeleton key={'pcs3'} />,
            <ProjectCardSkeleton key={'pcs4'} />,
            <ProjectCardSkeleton key={'pcs5'} />
        );

        divRole = Roles.pcSkeletonContainer;
    } else {
        panels.push(
            <CreateProjectCard key={'cpc'} onClick={onCreateProject} />
        );

        projects.forEach((p: IProject) => {
            panels.push(
                <ProjectCard
                    id={`${p.project_id}_card`}
                    key={`${p.project_id}-${p.project_name}`}
                    name={p.project_name}
                    isDepartmentLinked={!_isNil(p.department_id)}
                    onClick={() => onClick(p)}
                    onDelete={() => onDelete(p)}
                    onEditProjectName={() =>
                        onEdit(p, ManageProjectType.EDIT_NAME)
                    }
                />
            );
        });
        divRole = Roles.pcContainer;
    }

    return (
        <div
            id="project-cards-container"
            className={Styles.mainPanelCascade}
            role={divRole}
        >
            {panels}
        </div>
    );
};

export default ProjectCardList;
